module.exports = __webpack_public_path__ + "img/baseball.519bfc89.jpg";